@if (tokenValid()) {
    @if (roomValid()) {
        <app-header/>

        <div class="container-fluid px-3 px-md-4 py-3">
            <!-- Header Section -->
            <div class="mb-4">
                <h3 class="h4 fw-bold mb-1">Ihr Video Meeting</h3>
                <p class="text-muted small mb-0">Treten Sie dem Meeting bei</p>
            </div>

            <!-- Meeting Details Card -->
            <div class="card border-0 subtle-shadow mb-4 card-transparent">
                <div class="card-body p-3 p-md-4">
                    <!-- Topic & Date -->
                    <div class="mb-4">
                        <h4 class="h5 fw-bold mb-2">{{ room().topic }}</h4>
                        <div class="text-muted small">
                            <i class="fas fa-calendar-alt me-1"></i>
                            {{ room().date | date: 'dd.MM.yyyy HH:mm' }}
                        </div>
                    </div>

                    <!-- Agenda -->
                    @if (room().agenda) {
                        <div class="mb-3">
                            <h5 class="small fw-medium text-muted mb-1">Agenda</h5>
                            <p class="mb-0">{{ room().agenda }}</p>
                        </div>
                    }

                    <!-- Creator -->
                    <div class="mb-3">
                        <h5 class="small fw-medium text-muted mb-1">Ersteller</h5>
                        <p class="mb-0">{{ room().creator }}</p>
                    </div>

                    <!-- Participants -->
                    <div class="mb-3">
                        <h5 class="small fw-medium text-muted mb-2">Teilnehmer</h5>
                        <ul class="list-unstyled mb-0">
                            @for (participant of room().participants; track $index) {
                                <li class="mb-1">
                                    <i class="fas fa-user text-muted me-2"></i>
                                    <span class="small">{{ participant }}</span>
                                </li>
                            }
                        </ul>
                    </div>

                    <!-- Join Form -->
                    <div class="border-top pt-3">
                        <div class="mb-3">
                            <label for="name" class="form-label fw-medium small">Ihr Name</label>
                            <input id="name" type="text" class="form-control form-control-sm" [(ngModel)]="name" name="name"
                                   placeholder="Max Mustermann" required>
                        </div>

                        <div class="d-grid">
                            <button type="button" class="btn btn-primary" (click)="join()" [disabled]="!name">
                                <i class="fas fa-video me-1"></i>
                                Meeting beitreten
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div class="container-fluid px-3 py-5 text-center">
            <div class="alert alert-warning">Invalid room</div>
        </div>
    }
} @else {
    <div class="container-fluid px-3 py-5 text-center">
        <div class="alert alert-danger">Invalid token</div>
    </div>
}
